import { useMemo } from 'react';

import { useStores } from '../../../stores/useStores';
import type { PrizeDropWidgetDataType, WidgetEntry } from '../types';

export function usePrizeDropWidgets() {
  const { prizeDropStore } = useStores();

  const { prizeDropEvent } = prizeDropStore;

  const prizeDropWidgets: PrizeDropWidgetDataType[] = useMemo(() => {
    if (prizeDropEvent && !prizeDropEvent.isCrownSlotOnly) {
      return [
        {
          key: prizeDropEvent.id,
          event: prizeDropEvent,
          dataTestId: `metagames-${prizeDropEvent.typeName}-widget`,
        },
      ];
    }
    return [];
  }, [prizeDropEvent]);

  return useMemo(
    () => prizeDropWidgets.map((data): WidgetEntry<'prizeDrop'> => ({ data, type: 'prizeDrop', id: data.key })),
    [prizeDropWidgets],
  );
}
